
export const dateFormat = function (date) {
    var values = date.split(/[^0-9]/).reverse(),
        ano = parseInt(values[0], 10),
        mes = parseInt(values[1], 10) - 1, // mes is zero based, so subtract 1
        dia = parseInt(values[2], 10);

    return new Date(ano, mes, dia);
}

